// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gathering-page {
  --gathering-ink: #1c2940;
  --gathering-muted: #728096;
  --gathering-blue: #3969d9;
  min-height: 100vh;
  color: var(--gathering-ink);
  background: #f8faff;
}

.gathering-page *,
.gathering-page *::before,
.gathering-page *::after {
  box-sizing: border-box;
}

.gathering-header {
  position: relative;
  z-index: 1;
  height: 78px;
  padding: 0 7.2%;
  border-bottom: 1px solid #edf0f5;
  background: #fff;
}

.gathering-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1180px;
  height: 100%;
  margin: 0 auto;
}

.gathering-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #25344e;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.7px;
  text-decoration: none;
}

.gathering-brand-mark {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border-radius: 11px;
  color: #fff;
  background: linear-gradient(145deg, #5987f2, #3766d2);
  font-size: 18px;
}

.gathering-brand-light {
  color: #6c7d98;
  font-weight: 400;
}

.gathering-nav {
  display: flex;
  align-items: center;
  gap: 30px;
  height: 100%;
}

.gathering-nav-link {
  display: inline-flex;
  align-items: center;
  height: 100%;
  border-bottom: 2px solid transparent;
  color: #68768d;
  font-size: 14px;
  text-decoration: none;
  transition: border-color 160ms ease, color 160ms ease;
}

.gathering-nav-link:hover,
.gathering-nav-link-active {
  border-bottom-color: var(--gathering-blue);
  color: var(--gathering-blue);
}

.gathering-hero {
  position: relative;
  overflow: hidden;
  padding: 70px 24px 74px;
  background:
    radial-gradient(ellipse at 50% 0%, rgba(233, 240, 255, 0.8), transparent 62%),
    #f3f7ff;
  text-align: center;
}

.gathering-hero-content {
  position: relative;
  z-index: 1;
  max-width: 670px;
  margin: 0 auto;
}

.gathering-hero-icon {
  display: grid;
  width: 50px;
  height: 50px;
  place-items: center;
  margin: 0 auto 18px;
  border: 1px solid #dce7ff;
  border-radius: 16px;
  color: var(--gathering-blue);
  background: #fff;
  box-shadow: 0 9px 22px rgba(45, 83, 153, 0.08);
  font-size: 22px;
}

.gathering-eyebrow {
  margin: 0 0 10px;
  color: var(--gathering-blue);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.45px;
}

.gathering-hero h1 {
  margin: 0;
  color: #1c2940;
  font-size: clamp(38px, 5vw, 52px);
  letter-spacing: -2px;
  line-height: 1.12;
}

.gathering-hero-content > p:last-child {
  margin: 14px 0 0;
  color: var(--gathering-muted);
  font-size: 16px;
  line-height: 1.6;
}

.gathering-hero-orb {
  position: absolute;
  width: 170px;
  height: 170px;
  border: 1px solid rgba(180, 200, 242, 0.35);
  border-radius: 50%;
}

.gathering-hero-orb-one {
  top: 35px;
  left: max(calc((100vw - 1120px) / 2), 7%);
}

.gathering-hero-orb-two {
  right: max(calc((100vw - 1120px) / 2), 7%);
  bottom: -110px;
  width: 220px;
  height: 220px;
}

.gathering-feed {
  width: min(calc(100% - 48px), 1080px);
  margin: 0 auto;
  padding: 56px 0 76px;
}

.gathering-feed-heading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}

.gathering-feed-heading .gathering-eyebrow {
  margin-bottom: 8px;
}

.gathering-feed-heading h2 {
  margin: 0;
  color: #202d44;
  font-size: 30px;
  letter-spacing: -1px;
}

.gathering-post-count {
  padding: 7px 11px;
  border: 1px solid #e4eaf5;
  border-radius: 20px;
  color: #68768d;
  background: #fff;
  font-size: 12px;
}

.gathering-blog-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
  align-items: stretch;
}

.gathering-blog-card {
  overflow: hidden;
  min-width: 0;
  border: 1px solid #e7ebf1;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(46, 69, 112, 0.045);
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.gathering-blog-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 32px rgba(46, 69, 112, 0.1);
}

.gathering-blog-image {
  display: block;
  width: 100%;
  height: 190px;
  object-fit: cover;
  background: #edf2fb;
}

.gathering-blog-image-placeholder {
  display: grid;
  place-items: center;
  color: #91a5ce;
  font-size: 32px;
}

.gathering-blog-body {
  display: flex;
  flex-direction: column;
  min-height: 245px;
  padding: 19px;
}

.gathering-blog-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 16px;
  color: #8390a3;
  font-size: 11px;
}

.gathering-meta-dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #aab4c3;
}

.gathering-blog-body h3 {
  display: -webkit-box;
  overflow: hidden;
  margin: 12px 0 9px;
  color: #293750;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.4;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.gathering-blog-description {
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  color: #728096;
  font-size: 13px;
  line-height: 1.65;
  white-space: pre-line;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.gathering-read-label {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: auto;
  padding-top: 17px;
  color: var(--gathering-blue);
  font-size: 12px;
  font-weight: 700;
}

.gathering-read-label svg {
  font-size: 14px;
  transition: transform 160ms ease;
}

.gathering-blog-card:hover .gathering-read-label svg {
  transform: translateX(3px);
}

.gathering-state {
  display: flex;
  min-height: 230px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  border: 1px dashed #d9e1ee;
  border-radius: 15px;
  color: var(--gathering-muted);
  background: rgba(255, 255, 255, 0.72);
  text-align: center;
}

.gathering-state p {
  margin: 12px 0 0;
  font-size: 14px;
  line-height: 1.6;
}

.gathering-state h3 {
  margin: 13px 0 0;
  color: #35435a;
  font-size: 17px;
}

.gathering-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #dfe8fa;
  border-top-color: var(--gathering-blue);
  border-radius: 50%;
  animation: gathering-spin 750ms linear infinite;
}

.gathering-empty-icon {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  border-radius: 14px;
  color: var(--gathering-blue);
  background: #edf3ff;
  font-size: 20px;
}

.gathering-retry-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  padding: 10px 15px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  background: var(--gathering-blue);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.gathering-retry-button:hover {
  background: #2f5dc5;
}

.gathering-footer {
  padding: 0 7.2%;
  background: #fff;
}

.gathering-footer-inner {
  display: flex;
  width: 100%;
  max-width: 1180px;
  min-height: 76px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: 0 auto;
  border-top: 1px solid #edf0f5;
  color: #8b96a7;
  font-size: 12px;
}

.gathering-footer-brand {
  color: #35435a;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.gathering-footer-inner > a:last-child {
  color: #63718a;
  text-decoration: none;
}

.gathering-footer-inner > a:last-child:hover {
  color: var(--gathering-blue);
}

.gathering-brand:focus-visible,
.gathering-nav-link:focus-visible,
.gathering-footer a:focus-visible,
.gathering-retry-button:focus-visible {
  outline: 3px solid rgba(57, 105, 217, 0.35);
  outline-offset: 3px;
}

@keyframes gathering-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 900px) {
  .gathering-blog-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .gathering-header {
    height: 70px;
    padding: 0 18px;
  }

  .gathering-brand {
    gap: 8px;
    font-size: 16px;
  }

  .gathering-brand-mark {
    width: 30px;
    height: 30px;
    border-radius: 9px;
  }

  .gathering-nav {
    gap: 16px;
  }

  .gathering-nav-link {
    font-size: 12px;
  }

  .gathering-hero {
    padding: 53px 20px;
  }

  .gathering-hero h1 {
    font-size: 39px;
    letter-spacing: -1.6px;
  }

  .gathering-hero-content > p:last-child {
    font-size: 14px;
  }

  .gathering-hero-orb {
    opacity: 0.5;
  }

  .gathering-feed {
    width: calc(100% - 36px);
    padding: 39px 0 52px;
  }

  .gathering-feed-heading h2 {
    font-size: 26px;
  }

  .gathering-blog-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .gathering-blog-image {
    height: 205px;
  }

  .gathering-blog-body {
    min-height: 220px;
  }

  .gathering-footer {
    padding: 0 18px;
  }

  .gathering-footer-inner {
    flex-wrap: wrap;
    justify-content: center;
    min-height: 88px;
    gap: 8px 16px;
    padding: 15px 0;
    text-align: center;
  }

  .gathering-footer-inner > span {
    flex-basis: 100%;
    order: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .gathering-spinner {
    animation-duration: 2s;
  }

  .gathering-blog-card,
  .gathering-read-label svg {
    transition: none;
  }
}

.gathering-page {
  --gathering-ink: #17352d;
  --gathering-muted: #61766d;
  --gathering-blue: #10836b;
  background:
    radial-gradient(ellipse at 50% 17%, rgba(241, 248, 242, 0.95), transparent 44%),
    #f6faf6;
}

.gathering-header {
  border-bottom-color: #d5e0d8;
  background: rgba(250, 252, 249, 0.94);
}

.gathering-brand,
.gathering-feed-heading h2,
.gathering-blog-body h3 {
  color: #187d67;
}

.gathering-brand-light {
  color: #638076;
}

.gathering-brand-mark {
  background: linear-gradient(145deg, #159579, #08725d);
}

.gathering-nav-link {
  color: #64776e;
}

.gathering-nav-link:hover,
.gathering-nav-link-active {
  border-bottom-color: #13826a;
  color: #13826a;
}

.gathering-hero {
  background:
    radial-gradient(ellipse at 50% 0%, rgba(252, 255, 251, 0.9), transparent 64%),
    linear-gradient(155deg, #f6faf6 0%, #deecdf 100%);
}

.gathering-hero-icon {
  border-color: #c8ded1;
  color: #11836a;
  background: linear-gradient(155deg, #fff 8%, #e0eddf 100%);
  box-shadow: 0 10px 26px rgba(28, 101, 77, 0.09);
}

.gathering-eyebrow {
  color: #16816a;
}

.gathering-hero h1 {
  color: #137e68;
}

.gathering-hero-content > p:last-child {
  color: #61766d;
}

.gathering-hero-orb {
  border-color: rgba(89, 156, 125, 0.2);
}

.gathering-post-count {
  border-color: #cbdacf;
  color: #587166;
  background: rgba(255, 255, 255, 0.78);
}

.gathering-blog-card {
  border-color: #cddbd2;
  border-radius: 14px;
  background: linear-gradient(155deg, #fff 6%, #f1f7f0 100%);
  box-shadow: 0 8px 22px rgba(39, 87, 63, 0.055);
}

.gathering-blog-card:hover {
  box-shadow: 0 14px 30px rgba(39, 87, 63, 0.12);
}

.gathering-blog-image {
  background: #e4eee5;
}

.gathering-blog-image-placeholder {
  color: #4e9d80;
  background: linear-gradient(145deg, #f6faf5, #dfeddf);
}

.gathering-blog-meta {
  color: #718078;
}

.gathering-blog-body h3 {
  color: #284338;
}

.gathering-blog-description {
  color: #65796f;
}

.gathering-read-label {
  color: #13826a;
}

.gathering-state {
  border-color: #c8d9ce;
  color: #61766d;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.92), rgba(227, 239, 226, 0.82));
}

.gathering-state h3 {
  color: #284338;
}

.gathering-spinner {
  border-color: #dceade;
  border-top-color: #11836a;
}

.gathering-empty-icon {
  color: #13826a;
  background: #e3f0e5;
}

.gathering-retry-button {
  background: linear-gradient(110deg, #88c9b0, #48a98b);
}

.gathering-retry-button:hover {
  background: linear-gradient(110deg, #73bfa3, #329779);
}

.gathering-footer {
  background: rgba(255, 255, 255, 0.76);
}

.gathering-footer-inner {
  border-top-color: #d9e4db;
  color: #718078;
}

.gathering-footer-brand,
.gathering-footer-inner > a:last-child {
  color: #187d67;
}

.gathering-footer-inner > a:last-child:hover {
  color: #0c6f59;
}

.gathering-brand:focus-visible,
.gathering-nav-link:focus-visible,
.gathering-footer a:focus-visible,
.gathering-retry-button:focus-visible {
  outline-color: rgba(17, 131, 106, 0.42);
}
`, "",{"version":3,"sources":["webpack://./src/ComponentsCss/SocialGathering/SocialGathering.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;;EAEE,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB;;WAES;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;EAIE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB;;WAES;AACX;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE;;qDAEmD;AACrD;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,0DAA0D;EAC1D,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0DAA0D;EAC1D,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yFAAyF;AAC3F;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,uCAAuC;AACzC","sourcesContent":[".gathering-page {\n  --gathering-ink: #1c2940;\n  --gathering-muted: #728096;\n  --gathering-blue: #3969d9;\n  min-height: 100vh;\n  color: var(--gathering-ink);\n  background: #f8faff;\n}\n\n.gathering-page *,\n.gathering-page *::before,\n.gathering-page *::after {\n  box-sizing: border-box;\n}\n\n.gathering-header {\n  position: relative;\n  z-index: 1;\n  height: 78px;\n  padding: 0 7.2%;\n  border-bottom: 1px solid #edf0f5;\n  background: #fff;\n}\n\n.gathering-header-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 1180px;\n  height: 100%;\n  margin: 0 auto;\n}\n\n.gathering-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #25344e;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.7px;\n  text-decoration: none;\n}\n\n.gathering-brand-mark {\n  display: grid;\n  width: 34px;\n  height: 34px;\n  place-items: center;\n  border-radius: 11px;\n  color: #fff;\n  background: linear-gradient(145deg, #5987f2, #3766d2);\n  font-size: 18px;\n}\n\n.gathering-brand-light {\n  color: #6c7d98;\n  font-weight: 400;\n}\n\n.gathering-nav {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  height: 100%;\n}\n\n.gathering-nav-link {\n  display: inline-flex;\n  align-items: center;\n  height: 100%;\n  border-bottom: 2px solid transparent;\n  color: #68768d;\n  font-size: 14px;\n  text-decoration: none;\n  transition: border-color 160ms ease, color 160ms ease;\n}\n\n.gathering-nav-link:hover,\n.gathering-nav-link-active {\n  border-bottom-color: var(--gathering-blue);\n  color: var(--gathering-blue);\n}\n\n.gathering-hero {\n  position: relative;\n  overflow: hidden;\n  padding: 70px 24px 74px;\n  background:\n    radial-gradient(ellipse at 50% 0%, rgba(233, 240, 255, 0.8), transparent 62%),\n    #f3f7ff;\n  text-align: center;\n}\n\n.gathering-hero-content {\n  position: relative;\n  z-index: 1;\n  max-width: 670px;\n  margin: 0 auto;\n}\n\n.gathering-hero-icon {\n  display: grid;\n  width: 50px;\n  height: 50px;\n  place-items: center;\n  margin: 0 auto 18px;\n  border: 1px solid #dce7ff;\n  border-radius: 16px;\n  color: var(--gathering-blue);\n  background: #fff;\n  box-shadow: 0 9px 22px rgba(45, 83, 153, 0.08);\n  font-size: 22px;\n}\n\n.gathering-eyebrow {\n  margin: 0 0 10px;\n  color: var(--gathering-blue);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1.45px;\n}\n\n.gathering-hero h1 {\n  margin: 0;\n  color: #1c2940;\n  font-size: clamp(38px, 5vw, 52px);\n  letter-spacing: -2px;\n  line-height: 1.12;\n}\n\n.gathering-hero-content > p:last-child {\n  margin: 14px 0 0;\n  color: var(--gathering-muted);\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n.gathering-hero-orb {\n  position: absolute;\n  width: 170px;\n  height: 170px;\n  border: 1px solid rgba(180, 200, 242, 0.35);\n  border-radius: 50%;\n}\n\n.gathering-hero-orb-one {\n  top: 35px;\n  left: max(calc((100vw - 1120px) / 2), 7%);\n}\n\n.gathering-hero-orb-two {\n  right: max(calc((100vw - 1120px) / 2), 7%);\n  bottom: -110px;\n  width: 220px;\n  height: 220px;\n}\n\n.gathering-feed {\n  width: min(calc(100% - 48px), 1080px);\n  margin: 0 auto;\n  padding: 56px 0 76px;\n}\n\n.gathering-feed-heading {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.gathering-feed-heading .gathering-eyebrow {\n  margin-bottom: 8px;\n}\n\n.gathering-feed-heading h2 {\n  margin: 0;\n  color: #202d44;\n  font-size: 30px;\n  letter-spacing: -1px;\n}\n\n.gathering-post-count {\n  padding: 7px 11px;\n  border: 1px solid #e4eaf5;\n  border-radius: 20px;\n  color: #68768d;\n  background: #fff;\n  font-size: 12px;\n}\n\n.gathering-blog-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 22px;\n  align-items: stretch;\n}\n\n.gathering-blog-card {\n  overflow: hidden;\n  min-width: 0;\n  border: 1px solid #e7ebf1;\n  border-radius: 15px;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(46, 69, 112, 0.045);\n  transition: transform 180ms ease, box-shadow 180ms ease;\n}\n\n.gathering-blog-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 14px 32px rgba(46, 69, 112, 0.1);\n}\n\n.gathering-blog-image {\n  display: block;\n  width: 100%;\n  height: 190px;\n  object-fit: cover;\n  background: #edf2fb;\n}\n\n.gathering-blog-image-placeholder {\n  display: grid;\n  place-items: center;\n  color: #91a5ce;\n  font-size: 32px;\n}\n\n.gathering-blog-body {\n  display: flex;\n  flex-direction: column;\n  min-height: 245px;\n  padding: 19px;\n}\n\n.gathering-blog-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 16px;\n  color: #8390a3;\n  font-size: 11px;\n}\n\n.gathering-meta-dot {\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background: #aab4c3;\n}\n\n.gathering-blog-body h3 {\n  display: -webkit-box;\n  overflow: hidden;\n  margin: 12px 0 9px;\n  color: #293750;\n  font-size: 17px;\n  font-weight: 700;\n  line-height: 1.4;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n}\n\n.gathering-blog-description {\n  display: -webkit-box;\n  overflow: hidden;\n  margin: 0;\n  color: #728096;\n  font-size: 13px;\n  line-height: 1.65;\n  white-space: pre-line;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 4;\n}\n\n.gathering-read-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  margin-top: auto;\n  padding-top: 17px;\n  color: var(--gathering-blue);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.gathering-read-label svg {\n  font-size: 14px;\n  transition: transform 160ms ease;\n}\n\n.gathering-blog-card:hover .gathering-read-label svg {\n  transform: translateX(3px);\n}\n\n.gathering-state {\n  display: flex;\n  min-height: 230px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 30px;\n  border: 1px dashed #d9e1ee;\n  border-radius: 15px;\n  color: var(--gathering-muted);\n  background: rgba(255, 255, 255, 0.72);\n  text-align: center;\n}\n\n.gathering-state p {\n  margin: 12px 0 0;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.gathering-state h3 {\n  margin: 13px 0 0;\n  color: #35435a;\n  font-size: 17px;\n}\n\n.gathering-spinner {\n  width: 30px;\n  height: 30px;\n  border: 3px solid #dfe8fa;\n  border-top-color: var(--gathering-blue);\n  border-radius: 50%;\n  animation: gathering-spin 750ms linear infinite;\n}\n\n.gathering-empty-icon {\n  display: grid;\n  width: 44px;\n  height: 44px;\n  place-items: center;\n  border-radius: 14px;\n  color: var(--gathering-blue);\n  background: #edf3ff;\n  font-size: 20px;\n}\n\n.gathering-retry-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 16px;\n  padding: 10px 15px;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  background: var(--gathering-blue);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.gathering-retry-button:hover {\n  background: #2f5dc5;\n}\n\n.gathering-footer {\n  padding: 0 7.2%;\n  background: #fff;\n}\n\n.gathering-footer-inner {\n  display: flex;\n  width: 100%;\n  max-width: 1180px;\n  min-height: 76px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  margin: 0 auto;\n  border-top: 1px solid #edf0f5;\n  color: #8b96a7;\n  font-size: 12px;\n}\n\n.gathering-footer-brand {\n  color: #35435a;\n  font-size: 13px;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.gathering-footer-inner > a:last-child {\n  color: #63718a;\n  text-decoration: none;\n}\n\n.gathering-footer-inner > a:last-child:hover {\n  color: var(--gathering-blue);\n}\n\n.gathering-brand:focus-visible,\n.gathering-nav-link:focus-visible,\n.gathering-footer a:focus-visible,\n.gathering-retry-button:focus-visible {\n  outline: 3px solid rgba(57, 105, 217, 0.35);\n  outline-offset: 3px;\n}\n\n@keyframes gathering-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 900px) {\n  .gathering-blog-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 600px) {\n  .gathering-header {\n    height: 70px;\n    padding: 0 18px;\n  }\n\n  .gathering-brand {\n    gap: 8px;\n    font-size: 16px;\n  }\n\n  .gathering-brand-mark {\n    width: 30px;\n    height: 30px;\n    border-radius: 9px;\n  }\n\n  .gathering-nav {\n    gap: 16px;\n  }\n\n  .gathering-nav-link {\n    font-size: 12px;\n  }\n\n  .gathering-hero {\n    padding: 53px 20px;\n  }\n\n  .gathering-hero h1 {\n    font-size: 39px;\n    letter-spacing: -1.6px;\n  }\n\n  .gathering-hero-content > p:last-child {\n    font-size: 14px;\n  }\n\n  .gathering-hero-orb {\n    opacity: 0.5;\n  }\n\n  .gathering-feed {\n    width: calc(100% - 36px);\n    padding: 39px 0 52px;\n  }\n\n  .gathering-feed-heading h2 {\n    font-size: 26px;\n  }\n\n  .gathering-blog-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .gathering-blog-image {\n    height: 205px;\n  }\n\n  .gathering-blog-body {\n    min-height: 220px;\n  }\n\n  .gathering-footer {\n    padding: 0 18px;\n  }\n\n  .gathering-footer-inner {\n    flex-wrap: wrap;\n    justify-content: center;\n    min-height: 88px;\n    gap: 8px 16px;\n    padding: 15px 0;\n    text-align: center;\n  }\n\n  .gathering-footer-inner > span {\n    flex-basis: 100%;\n    order: 1;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .gathering-spinner {\n    animation-duration: 2s;\n  }\n\n  .gathering-blog-card,\n  .gathering-read-label svg {\n    transition: none;\n  }\n}\n\n.gathering-page {\n  --gathering-ink: #17352d;\n  --gathering-muted: #61766d;\n  --gathering-blue: #10836b;\n  background:\n    radial-gradient(ellipse at 50% 17%, rgba(241, 248, 242, 0.95), transparent 44%),\n    #f6faf6;\n}\n\n.gathering-header {\n  border-bottom-color: #d5e0d8;\n  background: rgba(250, 252, 249, 0.94);\n}\n\n.gathering-brand,\n.gathering-feed-heading h2,\n.gathering-blog-body h3 {\n  color: #187d67;\n}\n\n.gathering-brand-light {\n  color: #638076;\n}\n\n.gathering-brand-mark {\n  background: linear-gradient(145deg, #159579, #08725d);\n}\n\n.gathering-nav-link {\n  color: #64776e;\n}\n\n.gathering-nav-link:hover,\n.gathering-nav-link-active {\n  border-bottom-color: #13826a;\n  color: #13826a;\n}\n\n.gathering-hero {\n  background:\n    radial-gradient(ellipse at 50% 0%, rgba(252, 255, 251, 0.9), transparent 64%),\n    linear-gradient(155deg, #f6faf6 0%, #deecdf 100%);\n}\n\n.gathering-hero-icon {\n  border-color: #c8ded1;\n  color: #11836a;\n  background: linear-gradient(155deg, #fff 8%, #e0eddf 100%);\n  box-shadow: 0 10px 26px rgba(28, 101, 77, 0.09);\n}\n\n.gathering-eyebrow {\n  color: #16816a;\n}\n\n.gathering-hero h1 {\n  color: #137e68;\n}\n\n.gathering-hero-content > p:last-child {\n  color: #61766d;\n}\n\n.gathering-hero-orb {\n  border-color: rgba(89, 156, 125, 0.2);\n}\n\n.gathering-post-count {\n  border-color: #cbdacf;\n  color: #587166;\n  background: rgba(255, 255, 255, 0.78);\n}\n\n.gathering-blog-card {\n  border-color: #cddbd2;\n  border-radius: 14px;\n  background: linear-gradient(155deg, #fff 6%, #f1f7f0 100%);\n  box-shadow: 0 8px 22px rgba(39, 87, 63, 0.055);\n}\n\n.gathering-blog-card:hover {\n  box-shadow: 0 14px 30px rgba(39, 87, 63, 0.12);\n}\n\n.gathering-blog-image {\n  background: #e4eee5;\n}\n\n.gathering-blog-image-placeholder {\n  color: #4e9d80;\n  background: linear-gradient(145deg, #f6faf5, #dfeddf);\n}\n\n.gathering-blog-meta {\n  color: #718078;\n}\n\n.gathering-blog-body h3 {\n  color: #284338;\n}\n\n.gathering-blog-description {\n  color: #65796f;\n}\n\n.gathering-read-label {\n  color: #13826a;\n}\n\n.gathering-state {\n  border-color: #c8d9ce;\n  color: #61766d;\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.92), rgba(227, 239, 226, 0.82));\n}\n\n.gathering-state h3 {\n  color: #284338;\n}\n\n.gathering-spinner {\n  border-color: #dceade;\n  border-top-color: #11836a;\n}\n\n.gathering-empty-icon {\n  color: #13826a;\n  background: #e3f0e5;\n}\n\n.gathering-retry-button {\n  background: linear-gradient(110deg, #88c9b0, #48a98b);\n}\n\n.gathering-retry-button:hover {\n  background: linear-gradient(110deg, #73bfa3, #329779);\n}\n\n.gathering-footer {\n  background: rgba(255, 255, 255, 0.76);\n}\n\n.gathering-footer-inner {\n  border-top-color: #d9e4db;\n  color: #718078;\n}\n\n.gathering-footer-brand,\n.gathering-footer-inner > a:last-child {\n  color: #187d67;\n}\n\n.gathering-footer-inner > a:last-child:hover {\n  color: #0c6f59;\n}\n\n.gathering-brand:focus-visible,\n.gathering-nav-link:focus-visible,\n.gathering-footer a:focus-visible,\n.gathering-retry-button:focus-visible {\n  outline-color: rgba(17, 131, 106, 0.42);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
